import { render } from "./AccountTransactions.vue?vue&type=template&id=11224ad0"
import script from "./AccountTransactions.vue?vue&type=script&lang=js"
export * from "./AccountTransactions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mattday/Sites/swallowdental.co.uk/app/code/SwallowDental/CustomAccount/view/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/vue/screens/AccountTransactions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11224ad0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11224ad0', __exports__)) {
    api.reload('11224ad0', __exports__)
  }
  
  module.hot.accept("./AccountTransactions.vue?vue&type=template&id=11224ad0", () => {
    api.rerender('11224ad0', render)
  })

}


export default __exports__